<div class="chat" [class.chat--open]="!!activeKey">
  <!-- Beszélgetések -->
  <aside class="chat-side">
    <header class="chat-side__head">
      <h1>Chat</h1>
      <span class="chat-side__conn" *ngIf="!connected && !loading" title="Az élő kapcsolat újraépül — az üzenetek addig is mennek">Kapcsolódás…</span>
    </header>

    <div class="chat-share" *ngIf="shareCard && !active">
      <span>🔗 <b>{{ shareCard.title }}</b><br>Válaszd ki, kinek küldöd.</span>
      <button type="button" (click)="cancelShare()" aria-label="Megosztás elvetése">✕</button>
    </div>

    <label class="chat-search">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="20.5" y2="20.5"></line></svg>
      <input type="search" [(ngModel)]="search" placeholder="Keresés a csapatban" autocomplete="off">
    </label>

    <!-- Most online (mint a Messenger tetején) -->
    <div class="chat-online" *ngIf="onlinePeers.length && !search">
      <button type="button" class="chat-online__item" *ngFor="let m of onlinePeers" (click)="openMember(m)" [title]="m.name + ' — online'">
        <span class="cav cav--lg" [style.background]="color(m.name)">
          <img *ngIf="avatarPath(m) as p" [src]="p | chatBlob | async" alt="">
          <span>{{ initials(m.name) }}</span>
          <i class="cav__dot"></i>
        </span>
        <span class="chat-online__name">{{ firstName(m.name) }}</span>
      </button>
    </div>

    <div class="chat-list">
      <div class="chat-list__state" *ngIf="loading">Betöltés…</div>
      <div class="chat-list__state" *ngIf="error">Nem sikerült betölteni. <button type="button" (click)="load()">Újra</button></div>

      <button type="button" class="chat-item" *ngFor="let item of filteredItems; trackBy: trackItem"
              [class.chat-item--on]="activeKey === item.key"
              [class.chat-item--unread]="item.unread > 0 && !item.muted"
              (click)="open(item)">
        <span class="cav cav--md cav--group" *ngIf="!item.member">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8.5" r="3"></circle><path d="M3.5 19 a5.5 5.5 0 0 1 11 0"></path><circle cx="17" cy="8" r="2.4"></circle><path d="M15 14.5 a5 5 0 0 1 5.5 4.5"></path></svg>
        </span>
        <span class="cav cav--md" *ngIf="item.member" [style.background]="color(item.title)">
          <img *ngIf="avatarPath(item.member) as p" [src]="p | chatBlob | async" alt="">
          <span>{{ initials(item.title) }}</span>
          <i class="cav__dot" *ngIf="isOnline(item.member)"></i>
        </span>
        <span class="chat-item__body">
          <span class="chat-item__top">
            <span class="chat-item__name">{{ item.title }}</span>
            <span class="chat-item__time">{{ item.time }}</span>
          </span>
          <span class="chat-item__bottom">
            <span class="chat-item__preview">{{ item.preview }}</span>
            <svg *ngIf="item.muted" class="chat-item__muted" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16 V11 a6 6 0 0 1 9.5-4.9"></path><path d="M18 11 v5 l1.5 2 H8"></path><line x1="3" y1="3" x2="21" y2="21"></line></svg>
            <span class="chat-item__badge" *ngIf="item.unread > 0" [class.chat-item__badge--muted]="item.muted">{{ item.unread > 99 ? '99+' : item.unread }}</span>
          </span>
        </span>
      </button>
      <div class="chat-list__state" *ngIf="!loading && !error && search && !filteredItems.length">Nincs ilyen nevű tag.</div>
    </div>
  </aside>

  <!-- Beszélgetés -->
  <section class="chat-main">
    <app-chat-thread *ngIf="active"
                     [conversation]="active"
                     [members]="members"
                     [me]="me"
                     (back)="closeThread()"
                     (mutedChange)="onMutedChange($event)"></app-chat-thread>
    <div class="chat-empty" *ngIf="!active">
      <svg width="54" height="54" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5 h16 a1.5 1.5 0 0 1 1.5 1.5 v9 a1.5 1.5 0 0 1 -1.5 1.5 H10 l-4.5 3.5 V17.5 H4 A1.5 1.5 0 0 1 2.5 16 V7 A1.5 1.5 0 0 1 4 5.5 Z"></path><line x1="7" y1="10" x2="17" y2="10"></line><line x1="7" y1="13.5" x2="13" y2="13.5"></line></svg>
      <b>Csapatchat</b>
      <span>Válassz a bal oldali listából: a <b>Fő chat</b> mindenkinek szól, vagy írj valakinek külön.</span>
      <span class="chat-empty__tips">Húzz ide képet vagy fájlt · Rendelést, taskot, levelet is csatolhatsz a <b>+</b> gombbal</span>
    </div>
  </section>
</div>
